import Difficulty from './difficulty';
export default Difficulty;